import { render } from "./UrneView.vue?vue&type=template&id=4e07146c"
import script from "./UrneView.vue?vue&type=script&lang=js"
export * from "./UrneView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__